import ProspectProfileRow from "@/shared/components/ui/Avatar/ProspectProfileRow";
import { Clock, HandCoins, SquareCheckBig, Zap } from "lucide-react";
import React from "react";

const BantCell = ({ title, children, icon, bgColor, cardColor }) => (
  <div
    className={`rounded-xl ${cardColor} flex flex-col gap-2 p-3 min-h-[72px] min-w-[250px]`}
  >
    <div className="flex items-center gap-2">
      {icon && (
        <div
          className={`h-8 w-8 flex items-center justify-center rounded-full ${bgColor}`}
        >
          {icon}
        </div>
      )}
      <p className="text-[0.635rem] font-bold tracking-wide text-gray-800 dark:text-gray-100">
        {title}
      </p>
    </div>
    <div className="text-[0.68rem] text-gray-800 dark:text-gray-200 text-wrap font-normal leading-relaxed">
      {children}
    </div>
  </div>
);

const BantSummary = ({ bant }) => {
  if (!bant) return null;

  const authority = Array.isArray(bant.authority) ? bant.authority : [];
  const need = Array.isArray(bant.need) ? bant.need : [];

  return (
    <div className="shrink-0 flex flex-col gap-2">
      <p className="text-xs font-semibold text-gray-800 dark:text-gray-200 tracking-wide">
        BANT Qualification Summary
      </p>
      <div className="flex items-stretch gap-2 overflow-x-auto scrollbar-hide">
        <BantCell
          title="Budget"
          icon={<HandCoins size={16} className="text-white" />}
          bgColor="bg-secondary"
          cardColor="bg-secondary-light-transparent"
        >
          {bant.budget || "N/A"}
        </BantCell>
        <BantCell
          title="Authority"
          icon={<SquareCheckBig size={16} className="text-white" />}
          bgColor="bg-[#60A8D8]"
          cardColor="bg-[#60A8D814]"
        >
          <div className="flex flex-col gap-1.5">
            {authority.length > 0
              ? authority?.map((item) => (
                  <ProspectProfileRow
                    name={item.split(",")[0]}
                    email={item.split(",")[1]}
                    avatarUrl={item.avatarUrl}
                    avatarSize="sm"
                    number={item.number}
                    grayborderColor={true}
                  />
                ))
              : "N/A"}
          </div>
        </BantCell>
        <BantCell
          title="Need"
          bgColor="bg-[#76CEDB]"
          icon={<Zap size={16} className="text-white" />}
          cardColor="bg-[#76CEDB14]"
        >
          {need.length > 0 ? (
            <ul className="list-disc pl-4 space-y-2">
              {need.map((item, index) => (
                <li key={`${item}-${index}`}>{item}</li>
              ))}
            </ul>
          ) : (
            "N/A"
          )}
        </BantCell>
        <BantCell
          title="Timeline"
          icon={<Clock size={16} className="text-white" />}
          bgColor="bg-[#87cdba]"
          cardColor="bg-[#f5fbf9]"
        >
          {bant.timeline || "Yet to be discussed"}
        </BantCell>
      </div>
    </div>
  );
};

export default BantSummary;
